import { BACKEND } from "../config/configEnvs"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import axios from "axios"
import { MdSchedule } from "react-icons/md"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import Selector from "../components/ui/components/Selector"
import FullCalendar from "@fullcalendar/react"
import timeGridPlugin from "@fullcalendar/timegrid"
import { useSelector } from "react-redux"
import { Button } from "@mui/material"
import { FaFileExcel } from "react-icons/fa"
import { ExportarSeleccionExcel } from "../utils/automateFuncions/ExportarColeccionExcel"


const Schedule = () => {

  const user = useSelector((state) => state.auth.user)
  const profile = useSelector((state) => state.auth.profile)

  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"

  const [workers, setWorkers] = useState([])
  console.log(workers)
  const [loading, setLoading] = useState(false)
  const [view, setView] = useState("Calendarios") // Tabla | Calendarios

  const getWorkers = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${BACKEND}/api/getUsersIds/getWorkerUsers`)
      const validWorkers = response.data.filter((w) => w.puesto.toUpperCase() !== "JEFE DE PROYECTOS" && w.puesto.toUpperCase() !== "GERENTE GENERAL")
      setWorkers(validWorkers)
    } catch (error) {
      console.log(error)
      toast.error("Error obteniendo los trabajadores")
    } finally {
      setLoading(false)
    }
  }

  const timeToMinutes = (time) => { // Convertimos las horas a minutos
    if (!time || typeof time !== "string") return null;
    const parts = time.split(":");
    if (parts.length < 2) return null;
    const [hours, minutes] = parts.map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
  };

  const calculateDailyHours = (horaEntrada, horaSalida, horaEntradaAlmuerzo, horaSalidaAlmuerzo) => { // Calculamos las horas diarias
    if (!horaEntrada || !horaSalida) return 0;

    const entrada = timeToMinutes(horaEntrada);
    const salida = timeToMinutes(horaSalida);
    if (entrada === null || salida === null || salida <= entrada) return 0;

    let horasTrabajadas = (salida - entrada) / 60; // Convertir a horas

    // Restar almuerzo solo si está definido correctamente y hay intersección con la jornada
    const pausaInicio = timeToMinutes(horaEntradaAlmuerzo);
    const pausaFin = timeToMinutes(horaSalidaAlmuerzo);
    const pausaValida = pausaInicio !== null && pausaFin !== null && pausaFin > pausaInicio;
    if (pausaValida) {
      const overlapStart = Math.max(entrada, pausaInicio);
      const overlapEnd = Math.min(salida, pausaFin);
      if (overlapEnd > overlapStart) {
        horasTrabajadas -= (overlapEnd - overlapStart) / 60;
      }
    }

    return horasTrabajadas;
  };

  const calculateTotalHours = (schedule) => { // Calculamos las horas totales
    return schedule.reduce((total, day) => {
      return total + calculateDailyHours(
        day?.horaEntrada,
        day?.horaSalida,
        day?.horaEntradaAlmuerzo,
        day?.horaSalidaAlmuerzo
      );
    }, 0);
  };

  // Orden dinámico: 1) usuario actual, 2) misma área, 3) resto
  const sortWorkersForCurrentUser = (list) => {
    if (!Array.isArray(list)) return []
    const myId = profile?.id || user?.id
    const myName = profile?.name || user?.name
    const myEmail = profile?.email || user?.email
    const myArea = profile?.area || user?.area

    const isSelf = (w) => {
      const wid = w?.id || w?._id
      if (myId && wid) return wid === myId
      if (myEmail && w?.email) return w.email === myEmail
      if (myName && w?.name) return w.name === myName
      return false
    }

    const isSameArea = (w) => myArea && w?.area && w.area === myArea

    const weight = (w) => {
      if (isSelf(w)) return 0
      if (isSameArea(w)) return 1
      return 2
    }

    return [...list].sort((a, b) => {
      const wa = weight(a)
      const wb = weight(b)
      if (wa !== wb) return wa - wb
      const an = a?.name || ""
      const bn = b?.name || ""
      return an.localeCompare(bn)
    })
  }

  // (sin fechas específicas, usamos eventos recurrentes)

  // Construye eventos semanales RECURRENTES (Lun-Sáb) para referencia (sin fechas específicas)
  const buildWorkerWeeklyEvents = (worker) => {
    const events = [];

    // FullCalendar: daysOfWeek -> 0=Dom, 1=Lun, ... 6=Sáb
    for (let dayIndex = 0; dayIndex <= 5; dayIndex += 1) { // 0=Lunes ... 5=Sábado en worker.schedule
      const daySchedule = worker?.schedule?.[dayIndex];
      if (!daySchedule?.horaEntrada || !daySchedule?.horaSalida) continue;

      const startMin = timeToMinutes(String(daySchedule.horaEntrada));
      const endMin = timeToMinutes(String(daySchedule.horaSalida));
      if (endMin <= startMin) continue;

      // Horas de almuerzo por día (si existen)
      const lunchStartStr = daySchedule?.horaEntradaAlmuerzo || null;
      const lunchEndStr = daySchedule?.horaSalidaAlmuerzo || null;
      const lunchStartMin = timeToMinutes(lunchStartStr);
      const lunchEndMin = timeToMinutes(lunchEndStr);
      const hasValidLunch = lunchStartMin !== null && lunchEndMin !== null && lunchEndMin > lunchStartMin;

      const pushSegment = (segStartStr, segEndStr) => {
        const segStartMin = timeToMinutes(segStartStr);
        const segEndMin = timeToMinutes(segEndStr);
        if (segEndMin <= segStartMin) return;
        events.push({
          title: "",
          daysOfWeek: [dayIndex + 1],
          startTime: segStartStr,
          endTime: segEndStr,
          display: "block",
        });
      };

      // Dividir el turno alrededor del almuerzo (si corresponde)
      if (hasValidLunch) {
        // Si no hay superposición con la jornada, no dividir
        if (endMin <= lunchStartMin || startMin >= lunchEndMin) {
          pushSegment(String(daySchedule.horaEntrada), String(daySchedule.horaSalida));
        } else if (startMin < lunchStartMin && endMin > lunchEndMin) {
          // Cruza completamente el almuerzo
          pushSegment(String(daySchedule.horaEntrada), String(lunchStartStr));
          pushSegment(String(lunchEndStr), String(daySchedule.horaSalida));
        } else if (startMin < lunchStartMin && endMin > lunchStartMin && endMin <= lunchEndMin) {
          // Termina durante el almuerzo
          pushSegment(String(daySchedule.horaEntrada), String(lunchStartStr));
        } else if (startMin >= lunchStartMin && startMin < lunchEndMin && endMin > lunchEndMin) {
          // Comienza durante el almuerzo
          pushSegment(String(lunchEndStr), String(daySchedule.horaSalida));
        } else {
          // Turno completamente dentro del almuerzo: no hay segmento laboral que mostrar
        }
      } else {
        // Sin almuerzo configurado: turno completo
        pushSegment(String(daySchedule.horaEntrada), String(daySchedule.horaSalida));
      }

      // Agregar evento de almuerzo solo si está definido para ese día
      if (hasValidLunch) {
        events.push({
          title: "Almuerzo",
          daysOfWeek: [dayIndex + 1],
          startTime: String(lunchStartStr),
          endTime: String(lunchEndStr),
          display: "block",
          backgroundColor: "#fde68a",
          borderColor: "#f59e0b",
          textColor: "#7c2d12",
        });
      }
    }

    return events;
  };

  useEffect(() => {
    getWorkers()
  }, [])

  const exportToExcel = () => {
    try {
      const formatRange = (day) => {
        const start = day?.horaEntrada || "";
        const end = day?.horaSalida || "";
        if (!start || !end) return "";
        return `${start} - ${end}`;
      };

      const orderedWorkers = sortWorkersForCurrentUser(workers);
      const rows = orderedWorkers.map((w) => ({
        Nombre: w?.name || "",
        Área: w?.area || "",
        Puesto: w?.puesto || "",
        Lunes: formatRange(w?.schedule?.[0]),
        Martes: formatRange(w?.schedule?.[1]),
        Miércoles: formatRange(w?.schedule?.[2]),
        Jueves: formatRange(w?.schedule?.[3]),
        Viernes: formatRange(w?.schedule?.[4]),
        Sábado: formatRange(w?.schedule?.[5]),
        "Horas totales": Number(calculateTotalHours(w?.schedule || [])).toFixed(2),
      }));

      ExportarSeleccionExcel(rows, "Horarios");
    } catch (err) {
      console.log(err);
      toast.error("Error al exportar a Excel");
    }
  }

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Header */}
      <div className="flex flex-row py-2 bg-gray-100">
        <div className="flex px-4 wflex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex items-center gap-4 p-4">
            <MdSchedule className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">
              Horarios
            </h2>
          </div>

          {isAdmin && (
            <Button
              onClick={exportToExcel} 
              variant="contained" 
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "4px 24px",
                backgroundColor: "#2e7d32",
                transition: "all 0.3s ease",
                textTransform: "none",
                borderRadius: "8px",
                minWidth: "180px",
                maxWidth: "300px",
                '&:hover': {
                  backgroundColor: "#1b5e20",
                }
              }}
              endIcon={<FaFileExcel size={14} className="text-white"/>}
            >
              <span style={{ 
                whiteSpace: "nowrap", 
                overflow: "hidden", 
                textOverflow: "ellipsis",
                maxWidth: "300px"
              }}>
                Exportar a Excel
              </span>
            </Button>
          )}

          <div className="flex flex-row items-center justify-center gap-6 mr-8">
            <Selector
              title="Vista"
              value={view}
              setter={setView}
              options={[{label: "Tabla", value: "Tabla"}, {label: "Calendarios", value: "Calendarios"}]}
            />
            <div className="flex-row text-md gap-2 text-xs">
              <span className="font-semibold">Colaboradores: </span> 
              <span className="font-bold"> {workers.length}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto mt-0.5">
        {loading ? (
          <LoadingScreen />
        ) : (
          view === "Tabla" ? (
            <table className="min-w-full bg-white shadow-md rounded-lg">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr className="text-gray-700 text-left text-xs font-bold">
                  <th className="px-6 py-2 text-center w-[15%]">Nombre</th>
                  <th className="px-6 py-2 text-center w-[20%]">Puesto</th>
                  <th className="px-6 py-2 text-center">Lunes</th>
                  <th className="px-6 py-2 text-center">Martes</th>
                  <th className="px-6 py-2 text-center">Miércoles</th>
                  <th className="px-6 py-2 text-center">Jueves</th>
                  <th className="px-6 py-2 text-center">Viernes</th>
                  <th className="px-6 py-2 text-center">Sábado</th>
                  <th className="px-6 py-2 text-center">Horas totales</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {workers.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center py-4 text-gray-500">
                    Cargando...
                    </td>
                  </tr>
                ) : (
                sortWorkersForCurrentUser(workers).map((worker) => (
                  <tr key={worker.name} className="hover:bg-gray-50 text-xs transition-colors">
                    <td className="flex items-center px-6 py-2">
                        <img
                            className="h-10 w-10 rounded-full mr-4"
                            src={worker?.foto?.url ? worker?.foto?.url : "/assets/images/avatars/avatar_25.jpg"}
                            alt={worker.name}
                        />
                        <span className="font-medium text-gray-700">{worker.name}</span>
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.area} - {worker.puesto}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[0]?.horaEntrada} - {worker.schedule[0]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[1]?.horaEntrada} - {worker.schedule[1]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[2]?.horaEntrada} - {worker.schedule[2]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[3]?.horaEntrada} - {worker.schedule[3]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[4]?.horaEntrada} - {worker.schedule[4]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {worker.schedule[5]?.horaEntrada} - {worker.schedule[5]?.horaSalida}
                    </td>
                    <td className="px-6 py-4 text-center text-gray-600">
                        {calculateTotalHours(worker.schedule)} hrs
                    </td>
                  </tr>
                ))
                )}
              </tbody>
            </table>
          ) : (
            <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              {sortWorkersForCurrentUser(workers).map((worker) => (
                <div key={worker.name} className="bg-white shadow rounded-lg p-4">
                  <div className="flex sticky top-0 bg-white z-10 pt-2 flex-row items-center justify-between">
                    <div className="flex items-center gap-3 mb-3">
                      <img
                        className="h-8 w-8 rounded-full"
                        src={worker?.foto?.url ? worker?.foto?.url : "/assets/images/avatars/avatar_25.jpg"}
                        alt={worker.name}
                      />
                      <div className="flex flex-col">
                        <span className="text-sm font-semibold text-gray-800">{worker.name}</span>
                        <span className="text-xs text-gray-500">{worker.area} - {worker.puesto}</span>
                      </div>
                    </div>
                    <span className="text-sm font-semibold text-gray-900">Horas totales: {calculateTotalHours(worker.schedule)} hrs</span>
                  </div>
                  <FullCalendar
                    plugins={[timeGridPlugin]}
                    initialView="timeGridWeek"
                    height="auto"
                    locale="es"
                    timeZone="America/Lima" // GMT-5 sin DST
                    firstDay={1}
                    allDaySlot={false}
                    slotMinTime="06:00:00"
                    slotMaxTime="20:00:00"
                    stickyHeaderDates={false} 
                    slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                    eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                    nowIndicator={false}
                    headerToolbar={{ left: "", center: "", right: "" }}
                    dayHeaderFormat={{ weekday: 'long' }}
                    events={buildWorkerWeeklyEvents(worker)}
                    className="text-xs"
                  />
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
      
}

export default Schedule